import z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const ActivatePaymentDeferralWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('activatePaymentDeferralWorkoutPlan'),
  workoutPlanId: WorkoutPlanId,
});
export type ActivatePaymentDeferralWorkoutPlanEvent = z.infer<typeof ActivatePaymentDeferralWorkoutPlanEvent>;
